import { TerritoryModel } from './territory.model';
import { MediaModel } from './media.model';
import { CurrencyModel } from './currency.model';

export class ThirdPartyCreationRequestModel {
  public id: number = null;
  public requestType = '';
  public supplierType = '';
  public dateCreation: any = null;
  public userCreation = '';
  public service = '';
  public tel = '';
  public label = '';
  public address = '';
  public zipCode = '';
  public country: TerritoryModel;
  public city = '';
  public intraCommunautaireTvaNumber = '';
  public siret = '';
  public socialSecurity = '';
  public agessaAgrement = '';
  public existMilo = false;
  public blocageReason = '';
  public miloIdentification = '';
  public miloBlockedCompta = false;
  public miloBlockedMM = false;
  public email = '';
  public thirdPartyType = '';
  public honoraire = false;
  public currency: CurrencyModel;
  public amount = '';
  public commandeVerso = false;
  public commandeRambo = false;
  public commandeBBP = false;
  public contratRambo = false;
  public clientType = '';
  public clientCountry: TerritoryModel;
  public mediaCountry: MediaModel;
  public clientHermes: boolean;
  public clientContratRambo: boolean;
  public clientContratRamboUTD: boolean;
  public clientVenteSD: boolean;
  public clientAutres: boolean;
  public category = '';
  public personCompanyType = '';
  public statusCreationRequest: boolean;

  constructor() {}

  public fromJSON(json) {
    for (const propName in json) {
      if (json.hasOwnProperty(propName)) {
        this[propName] = json[propName];
      }
    }
    return this;
  }
}
